import { z } from 'zod';

export const attendeeSchema = z.object({
	anrede: z
		.union([z.literal(''), z.literal('Herr'), z.literal('Frau'), z.literal('Divers')])
		.refine((val) => val !== '', {
			message: 'Bitte wählen Sie eine Anrede aus',
		}),
	vorname: z
		.string({
			required_error: 'Bitte geben Sie einen Vornamen ein',
		})
		.min(1, 'Bitte geben Sie einen Vornamen ein')
		.max(100, 'Die maximale Länge ist 100 Zeichen'),
	nachname: z
		.string({
			required_error: 'Bitte geben Sie einen Nachnamen ein',
		})
		.min(1, 'Bitte geben Sie einen Nachnamen ein')
		.max(100, 'Die maximale Länge ist 100 Zeichen'),
	email: z.string().email('Gib eine gültige E-Mail Adresse ein.').optional(),
});
export const attendeesFormSchema = z.object({
	attendees: z.array(attendeeSchema).min(1, 'Mindestens ein Teilnehmer ist erforderlich'),
});
export type AttendeesFormData = z.infer<typeof attendeesFormSchema>;

export const digitalizationAttendeeSchema = attendeeSchema.extend({
	email: z
		.string({
			required_error: 'Bitte geben Sie eine E-Mail Adresse ein',
		})
		.email('Gib eine gültige E-Mail Adresse ein.'),
});
export const digitalizationAttendeesFormSchema = z.object({
	attendees: z
		.array(digitalizationAttendeeSchema)
		.min(1, 'Mindestens ein Teilnehmer ist erforderlich'),
	agbAccepted: z.boolean().refine((val) => val, {
		message: 'Bitte akzeptieren Sie die AGB',
	}),
});
export type DigitalizationAttendeesFormData = z.infer<typeof digitalizationAttendeesFormSchema>;
